import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class FormCardSelect extends Component {
  handleOnClick() {
    if (!this.props.input) {
      return;
    }

    const {
      fieldValue,
      input: { onChange, value },
    } = this.props;

    if (fieldValue === value) {
      onChange(null);

      return;
    }

    onChange(fieldValue);
  }

  render() {
    let { big, onClick, input, active, fieldValue } = this.props;

    onClick = onClick || this.handleOnClick.bind(this);

    if (!active && input) {
      active = fieldValue === input.value;
    }

    let className = cx({
      formCardSelect: true,
      active: active,
      big: big,
    });

    return (
      <div className={classnames(className)} onClick={onClick}>
        <div className="container">{this.props.children}</div>
      </div>
    );
  }
}
